export interface Post {
  id: number;
  username: string;
  title: string;
  platform: string;
  type: string;
  publishedDate: string;
  views: number;
  likes: number;
  comments: number;
  shares: number;
  er: number;
  cpe: number;
  cpl: number;
  cpc: number;
  cpv: number;
  cost?: number;
  postUrl?: string;
}

export const initialPostsData: Post[] = [
  {
    id: 1,
    username: '@sarahjohnson',
    title: 'Summer Skincare Routine 2024',
    platform: 'Instagram',
    type: 'Reel',
    publishedDate: '2024-08-05',
    views: 124500,
    likes: 12450,
    comments: 892,
    shares: 345,
    er: 10.0,
    cpe: 0.82,
    cpl: 0.12,
    cpc: 1.45,
    cpv: 0.012,
    cost: 1500,
    postUrl: 'https://instagram.com/p/example1'
  },
  {
    id: 2,
    username: '@emmawilliams',
    title: 'Unboxing New Beauty Products',
    platform: 'YouTube',
    type: 'Video',
    publishedDate: '2024-08-03',
    views: 98700,
    likes: 8876,
    comments: 543,
    shares: 0,
    er: 9.0,
    cpe: 0.95,
    cpl: 0.15,
    cpc: 2.12,
    cpv: 0.022,
    cost: 2200,
    postUrl: 'https://youtube.com/watch?v=example2'
  },
  {
    id: 3,
    username: '@lisachen',
    title: 'Morning Skincare Tips',
    platform: 'Instagram',
    type: 'Photo',
    publishedDate: '2024-08-01',
    views: 87600,
    likes: 7446,
    comments: 456,
    shares: 234,
    er: 8.5,
    cpe: 0.78,
    cpl: 0.11,
    cpc: 1.32,
    cpv: 0.009,
    cost: 800,
    postUrl: 'https://instagram.com/p/example3'
  },
  {
    id: 4,
    username: '@michaelbrown',
    title: 'Product Review: Natural Moisturizer',
    platform: 'Facebook',
    type: 'Video',
    publishedDate: '2024-07-30',
    views: 76500,
    likes: 6120,
    comments: 389,
    shares: 456,
    er: 8.0,
    cpe: 0.88,
    cpl: 0.14,
    cpc: 1.28,
    cpv: 0.016,
    cost: 1200,
    postUrl: 'https://facebook.com/example4'
  },
  {
    id: 5,
    username: '@jessicamartinez',
    title: 'Makeup Tutorial - Natural Look',
    platform: 'Instagram',
    type: 'Reel',
    publishedDate: '2024-07-28',
    views: 69800,
    likes: 5235,
    comments: 312,
    shares: 189,
    er: 7.5,
    cpe: 0.92,
    cpl: 0.13,
    cpc: 1.56,
    cpv: 0.014,
    cost: 950,
    postUrl: 'https://instagram.com/p/example5'
  },
  {
    id: 6,
    username: '@davidlee',
    title: 'Skincare Myths Debunked',
    platform: 'YouTube',
    type: 'Short',
    publishedDate: '2024-07-25',
    views: 65400,
    likes: 4908,
    comments: 278,
    shares: 0,
    er: 7.2,
    cpe: 1.05,
    cpl: 0.16,
    cpc: 2.45,
    cpv: 0.028,
    cost: 1800,
    postUrl: 'https://youtube.com/shorts/example6'
  },
  {
    id: 7,
    username: '@amyjones',
    title: 'Fall Beauty Haul',
    platform: 'Facebook',
    type: 'Image',
    publishedDate: '2024-07-22',
    views: 54300,
    likes: 3876,
    comments: 234,
    shares: 312,
    er: 6.8,
    cpe: 0.91,
    cpl: 0.13,
    cpc: 1.42,
    cpv: 0.011,
    cost: 600,
    postUrl: 'https://facebook.com/example7'
  }
];

export function calculateTotalSpent(posts: Post[], platform: string = 'all'): number {
  const filteredPosts = platform === 'all' 
    ? posts 
    : posts.filter(p => p?.platform === platform);
  
  return filteredPosts.reduce((total, post) => {
    return total + (post.cost || 0);
  }, 0);
}

export function calculatePlatformSpending(posts: Post[]): { [key: string]: number } {
  const spending: { [key: string]: number } = {
    Instagram: 0,
    YouTube: 0,
    Facebook: 0
  };

  posts.forEach(post => {
    if (spending[post.platform] !== undefined) {
      spending[post.platform] += (post.cost || 0);
    }
  });

  return spending;
}
